<ion-content [@slideInTop]>
  <div class="messagerie-page-wrapper">
    <header class="messagerie-page-header">
      <button (click)="goBack()" class="back-button"></button>
      <div class="header-info">
        <ng-container *ngIf="!isLoading; else headerSkeleton">
          <img
            *ngIf="
              receiver_data && receiver_data.image && messagesType === 'users'
            "
            class="user-img"
            [src]="
              receiver_data.image
                ? receiver_data.image
                : '../../../assets/icon/icone-profile/profile_img.svg'
            "
            alt="user image"
          />
          <img
            *ngIf="messagesType === 'admins'"
            class="user-img"
            src="../../../assets/icon/logo.png"
            alt="user image"
          />
          <div class="name-status">
            <p *ngIf="messagesType == 'admins'" class="user-name">Bob Express</p>
            <p
              *ngIf="(receiver_data || conversatinName.length > 0) && messagesType === 'users'"
              class="user-name"
            >
              {{ getConversationName() }}
            </p>
          </div>
        </ng-container>
        <ng-template #headerSkeleton>
          <ion-skeleton-text animated style="width: 40px; height: 40px; border-radius: 50%"></ion-skeleton-text>
          <div style="margin-left: 12px; width: 160px">
            <ion-skeleton-text animated style="width: 100%; height: 16px"></ion-skeleton-text>
            <ion-skeleton-text animated style="width: 60%; height: 12px; margin-top: 6px"></ion-skeleton-text>
          </div>
        </ng-template>
      </div>
    </header>

    <main class="messagerie-main">
      <div #messageContainer class="messagerie-wrapper">
        <ng-container *ngIf="!isLoading; else listSkeleton">
          <div *ngFor="let messageGroup of convMessages">
            <div class="time-bloc">
              <p class="time">{{ messageGroup.date }}</p>
            </div>
            <div
              class="message-bloc-container"
              *ngFor="let message of messageGroup.messages"
            >
              <div
                class="message-bloc"
                [ngClass]="{
                  sender:
                    message.user1_id === current_user.id || message.sender === 0,
                  reciever:
                    message.user2_id === current_user.id || message.sender === 1,
                }"
                [ngStyle]="
                  message.duration
                    ? {
                        width: message.duration + '%',
                        'max-width': 90 + '%;',
                        padding: '18px 2px 0px 5px',
                      }
                    : {}
                "
              >
                <p class="time">
                  {{ fetchTimeWithoutSeconds(message.created_at)
                  }}{{
                    toNumber(
                      fetchTimeWithoutSeconds(message.created_at).split(":")[0]
                    ) >= 12
                      ? " PM"
                      : " AM"
                  }}
                </p>
                <app-audio-player
                  *ngIf="message.type === 'audio'"
                  [duration]="message.duration"
                  [url]="message.message ? message.message : message.last_message"
                  [styles]="{ backgroundColor: 'transparent', border: 'none' }"
                  (playRequest)="handleAudioPlay($event)"
                ></app-audio-player>
                <p class="message" *ngIf="message.type === 'text'">
                  {{ message.message ? message.message : message.last_message }}
                </p>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #listSkeleton>
          <div style="padding: 12px 16px">
            <ion-skeleton-text animated style="width: 30%; height: 12px; margin: 6px 0"></ion-skeleton-text>
            <div *ngFor="let i of [1,2,3,4,5]" style="margin: 10px 0">
              <ion-skeleton-text animated style="width: 60%; height: 16px"></ion-skeleton-text>
              <ion-skeleton-text animated style="width: 40%; height: 16px; margin-top: 6px"></ion-skeleton-text>
            </div>
          </div>
        </ng-template>
        <div class="input-container">
          <app-messagerie-text-input
            (send)="handleMessage($event)"
            (onChange)="onMessageInputChange($event)"
            (inputFocus)="onInputFocus()"
            (recordingStateChange)="onRecordingStateChange($event)"
          />
        </div>
      </div>
    </main>
  </div>
</ion-content>
